import RadioGroup from '@ecp/common/src/components/radio/RadioGroup';

export default RadioGroup;
